import { LocalizedForm } from "common/localization";

export default class PodcastEpisodeEditTitleForm extends LocalizedForm {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: "title",
                    label: "ADMINISTRATION.PODCAST.EPISODES.FIELDS.TITLE_LABEL",
                    placeholder: "ADMINISTRATION.PODCAST.EPISODES.FIELDS.TITLE_PLACEHOLDER",
                    rules: "required|string",
                },
            ],
        };
    }
}
